import React from 'react'
import { SimpleGrid, Box, Text, VStack, Icon, useColorModeValue } from '@chakra-ui/react'
import { FiLayers, FiCheck, FiTool, FiUsers } from 'react-icons/fi'

interface PlansStatsProps {
  stats: {
    total: number
    active: number
    custom: number
    totalOrganizations: number
  }
}

interface StatCardProps {
  label: string
  value: number
  icon: React.ElementType
  colorScheme: string
}

function StatCard({ label, value, icon, colorScheme }: StatCardProps) {
  const bgColor = useColorModeValue(`${colorScheme}.50`, `${colorScheme}.900`)
  const textColor = useColorModeValue(`${colorScheme}.600`, `${colorScheme}.200`)
  const valueColor = useColorModeValue(`${colorScheme}.800`, `${colorScheme}.100`)

  return (
    <Box
      bg={bgColor}
      p={6}
      borderRadius="xl"
      border="1px solid"
      borderColor={useColorModeValue(`${colorScheme}.100`, `${colorScheme}.700`)}
      _hover={{
        transform: 'translateY(-2px)',
        boxShadow: 'lg',
      }}
      transition="all 0.2s"
    >
      <VStack spacing={3} align="start">
        <Icon as={icon} boxSize={6} color={textColor} />
        <VStack spacing={1} align="start">
          <Text fontSize="sm" color={textColor} fontWeight="medium">
            {label}
          </Text>
          <Text fontSize="3xl" fontWeight="bold" color={valueColor}>
            {value.toLocaleString()}
          </Text>
        </VStack>
      </VStack>
    </Box>
  )
}

export default function PlansStats({ stats }: PlansStatsProps) {
  return (
    <SimpleGrid columns={{ base: 2, md: 4 }} spacing={6}>
      <StatCard label="Total Plans" value={stats.total} icon={FiLayers} colorScheme="blue" />
      <StatCard label="Active Plans" value={stats.active} icon={FiCheck} colorScheme="green" />
      <StatCard label="Custom Plans" value={stats.custom} icon={FiTool} colorScheme="orange" />
      <StatCard
        label="Organizations"
        value={stats.totalOrganizations}
        icon={FiUsers}
        colorScheme="purple"
      />
    </SimpleGrid>
  )
}
